import React from 'react';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {withTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import InputTextComponent from '../components/inputs/InputTextComponent';
import ContactPersonsModel from '../model/ContactPersonsModel';
import DivContainer from '../components/DivContainer';
import {ActionButton} from '../components/ActionButton';
import ProfileService from '../services/ProfileService';
import ActionLink from '../components/ActionLink';
import {v4 as uuidv4} from 'uuid';
import {Dialog} from 'primereact/dialog';
import BlockUi from '../components/waitPanel/BlockUi';
import {Card} from 'primereact/card';
import BannerComponent from '../components/BannerComponent';
import InputRadioButtonComponent from '../components/inputs/InputRadioButtonComponent';

class ContactPersonsDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new ProfileService());
        this.state = {
            elementId: props.elementId,
            element: new ContactPersonsModel(),
            viewMode: 'EDIT',
            cardLoading: false,
            twoStepAuthChosen: {enumValue: 'PHONE', label: "numer telefonu"},
            twoStepAuthPaths:[
                {enumValue: 'PHONE', label: "numer telefonu"},
                {enumValue: 'EMAIL', label: "adres e-mail"},
               
            ],
        };
       
        this.handleAddElement = this.handleAddElement.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton
                    label={t('details.cancel')}
                    variant={this.state.viewMode === 'DELETE' ? 'button cancel-button red' : 'button cancel-button white'}
                    handleClick={this.props.onHide}
                />
                <ActionButton
                    label={t('details.saveChanges')}
                    variant='button save-button blue'
                    handleClick={this.handleFormSubmit}
                    rendered={this.state.viewMode !== 'DELETE'}
                />
            </div>
        );
    }

    handleFormSubmit(event) {
        if (event !== undefined) {
            event.preventDefault();
        }
        if (this.validator.allValid()) {
            if (!!this.props.beforeSave) {
                this.setState({cardLoading: true}, () => this.props.beforeSave(this.handleValidForm));
            } else {
                this.blockUi(this.handleValidForm);
            }
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    renderHeader() {
        const {t, notificationType} = this.props;
        return (
            <DivContainer colClass='col-12 transaction-dialog-header'>
                <DivContainer colClass='col-12'>
                    <label>
                       {notificationType ? t(`profile.${notificationType}`) : t('profile.editCustomerDataHeader' ) }
                    </label>
                </DivContainer>
            </DivContainer>
        );
    }
    updateElement(data) {
        this.setState(
            {
                element: ContactPersonsModel.copy(data),
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }
    setElement() {
        if (this.props.element) {
            this.updateElement(this.props.element);
        }
    }
    getContainerListName() {
        return 'profile-container';
    }
    getAddSucces() {
        return 'Osoba kontaktowa została utworzona';
    }

    getUpdateSucces() {
        const {t} = this.props;
        return t('profile.successEdit');
    }

    render() {
        const {className, id, key, name, onHide, visible, style} = this.props;
        return (
            <Dialog
                ariaCloseIconLabel={this.translate('dialog.closeDialog')}
                header={this.renderHeader()}
                visible={visible}
                className={className}
                style={style}
                key={`${key ? key : id ? id : name}-dialog`}
                onHide={() => (onHide ? onHide() : null)}
                closable={this.state.closable}
            >
                {this.state.loading ? null : (
                    <Card footer={this.renderFooter()}>
                        <BlockUi tag='div' blocking={this.state.cardLoading} loader={this.loader} loaderType='small-loader' horizontal>
                            <form onSubmit={this.handleFormSubmit} noValidate onKeyDown={(e) => this.onKeyDown(e)}>
                                {this.renderDetails()}
                            </form>
                        </BlockUi>
                    </Card>
                )}
            </Dialog>
        );
    }
    createOrUpdate() {
        const {element} = this.state;
        element.own = !element.notOwn;
        element.useEmail = this.state.element.twoStepAuthChosen === 'EMAIL' ? true : false;
        element.usePhone = this.state.element.twoStepAuthChosen === 'PHONE' ? true : false;
        this.scrollToTop();
        if (this._isMounted) {
            this.service
                .editProfileInfo(element, this.props.userAgreementMapId)
                .then((response) => {
                    this.showSuccessMessage(this.getUpdateSucces(response));
                    if (this.props.afterSave) {
                        this.props.afterSave(response);
                    }
                })
                .catch((err) => {
                    this.showErrorMessage(err.message);
                    if (this.props.afterSave) {
                        this.props.afterSave();
                    }
                });
        }
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    handleAddElement(listName, newElement) {
        const modifiedList = this.state.element[`${listName}`];
        modifiedList.push(newElement);
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                [listName]: modifiedList,
            },
        }));
    }
    handleRemove(e, listName, uuid) {
        if (e) {
            e.preventDefault();
        }
        const modifiedList = this.state.element[`${listName}`];
        let index;
        modifiedList.forEach((element, i) => {
            if (element.uuid === uuid) {
                index = i;
            }
        });
        modifiedList.splice(index, 1);
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                [listName]: modifiedList,
            },
        }));
    }
    renderDetails() {
        const {t, notificationType} = this.props;
        return (
            <React.Fragment>
                {notificationType === 'MARKETING_NOTIFICATION'?  
                  <div className='marketing-notification-banner'>  
                  <BannerComponent
                              key={'header-banner'}
                              label={t('profile.bannerMarketing')}
                              iconSvg='ico_blue_banner_icon'
                              iconSide='left'
                              variant='blue-banner'
                          ></BannerComponent>
                 </div> 
                : null }
              
                <div className='row '>
                {notificationType !== '' && notificationType !== 'TWO_STEP_AUTH_EDIT' ?
                    <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                        <label className='p-label' style={{margin: '0px'}}>{t('profile.notificationPhoneNumber')}</label>
                        { this.state.element.notificationPhoneNumbers.map((notificationPhoneNumber, index) => {
                              //.filter(e => e.notificationTypeTranslated === notificationType)
                              if(notificationPhoneNumber.notificationTypeTranslated === notificationType){

                                return (
                                    <React.Fragment key={`profile-notificationPhoneNumber-${index}`}>
                                        <div className='row'>
                                            <InputTextComponent
                                                key={`notificationPhoneNumber-${index}`}
                                                id={`notificationPhoneNumber-${index}`}
                                                name='address'
                                                label={t('profile.notificationPhoneNumber')}
                                                colClass='col-11'
                                                stateField={`element.notificationPhoneNumbers[${index}]`}
                                                viewMode={this.state.viewMode}
                                               // showLabel={index === 0}
                                                showLabel={false}
                                                onChange={this.handleChange}
                                                value={notificationPhoneNumber.address}
                                                validator={this.validator}
                                                //validators={`${index === 0 ? 'not_required' : 'required'}|phone`}
                                                validators={'required|phone'}
                                                keyfilter={/^[()0-9]*$/i}
                                                forcePrefixRegEx={/^\([0-9]{1,4}\)/i}
                                                partialPrefixRegEx={/^\([0-9]{1,4}\)|\([0-9]{1,4}|\(/gi}
                                                defaultPrefix='(48)'
                                            />
                                            <div className='col-1 trash-input'>
                                                <ActionLink
                                                    className='trash-input-button float-right'
                                                    iconSvg='ico_trash_inputtext'
                                                    iconSide='left'
                                                    label=''
                                                    handleClick={(e) =>
                                                        this.handleRemove(e, 'notificationPhoneNumbers', notificationPhoneNumber.uuid)
                                                    }
                                                    id={`delete_person_${index}`}
                                                   // rendered={index !== 0}
                                                    title='Przycisk usunięcie pola'
                                                />
                                            </div>
                                        </div>
                                       {/*  {index === phoneListLength - 1 || phoneListLength === undefined ? (
                                            <div className='row add-button-row'>
                                                <div className='col-6 margin-top-8'>
                                                    <ActionButton
                                                        label={t('details.addButton')}
                                                        variant={'white'}
                                                        //handleClick={this.handleAddPerson}
                                                        handleClick={(e) =>
                                                            this.handleAddElement('notificationPhoneNumbers', {
                                                                address: '',
                                                                id: undefined,
                                                                uuid: uuidv4(),
                                                                notificationTypeTranslated: notificationType,
                                                            })
                                                        }
                                                        iconSvg='ico_plus'
                                                        iconSide='left'
                                                      //  disabled={this.state.element.notificationPhoneNumbers.length === 5}
                                                    />
                                                </div>
                                            </div>
                                        ) : null} */}
                                    </React.Fragment>
                                ); 
                              } else return null;
                       
                                
                                
                              })
                   
                            
                            }

                        <div className='row add-button-row'>
                                                    <div className='col-6 margin-top-8'>
                                                        <ActionButton
                                                            label={t('details.addButton')}
                                                            variant={'white'}
                                                            //handleClick={this.handleAddPerson}
                                                            handleClick={(e) =>
                                                                this.handleAddElement('notificationPhoneNumbers', {
                                                                    address: '',
                                                                    id: undefined,
                                                                    uuid: uuidv4(),
                                                                    notificationTypeTranslated: notificationType,
                                                                })
                                                            }
                                                            iconSvg='ico_plus'
                                                            iconSide='left'
                                                            //disabled={this.state.element.notificationPhoneNumbers.filter(el => el.notificationTypeTranslated=== notificationType).length === 5}
                                                        />
                                                    </div>
                                                </div> 
                    </div> : null}

                   {notificationType !== '' && notificationType !== 'TWO_STEP_AUTH_EDIT' ?
                  <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                 <label className='p-label' style={{margin: '0px'}}>{t('profile.notificationEmail')}</label>
                      { this.state.element.notificationEmails.map((notificationEmail, index) => {
                        if(notificationEmail.notificationTypeTranslated  === notificationType){
                            return (
                                <React.Fragment key={`profile-notificationEmails-${index}`}>
                                    <div className='row'>
                                        <InputTextComponent
                                            key={`notificationEmail-${index}`}
                                            id={`notificationEmail-${index}`}
                                            name='address'
                                            label={t('profile.notificationEmail')}
                                            colClass='col-11'
                                            stateField={`element.notificationEmails[${index}]`}
                                            viewMode={this.state.viewMode}
                                            //showLabel={index === 0}
                                            showLabel={false}
                                            onChange = {this.handleChange}
                                            value={notificationEmail.address}
                                            validator={this.validator}
                                            validators={'required|email'}
                                        />
                                        <div className='col-1 trash-input'>
                                            <ActionLink
                                                className='trash-input-button float-right'
                                                iconSvg='ico_trash_inputtext'
                                                label=''
                                                iconSide='left'
                                                handleClick={(e) =>
                                                    this.handleRemove(e, 'notificationEmails', notificationEmail.uuid)
                                                }
                                                id={`delete_person_${index}`}
                                                rendered={(index !== 0 && notificationType === 'REQUIRED_NOTIFICATION' ) || (notificationType !== 'REQUIRED_NOTIFICATION'  && notificationType !== 'TWO_STEP_AUTH_EDIT') }
                                                title='Przycisk usunięcie pola'
                                            />
                                        </div>
                                    </div>
                                   {/*  {index === emailListLength - 1 || index > emailListLength  ? (
                                        <div className='row add-button-row'>
                                            <div className='col-6 margin-top-8'>
                                                <ActionButton
                                                    label={t('details.addButton')}
                                                    variant={'white'}
                                                    handleClick={(e) =>
                                                        this.handleAddElement('notificationEmails', {
                                                            address: '',
                                                            uuid: uuidv4(),
                                                            notificationTypeTranslated: notificationType,
                                                        })
                                                    }
                                                    iconSvg='ico_plus'
                                                    iconSide='left'
                                                   // disabled={this.state.element.notificationEmails.length === 5}
                                                />
                                            </div>
                                        </div>
                                    ) : null} */}
                                </React.Fragment>
                            ); 
                        } else return null;

                        }
                     )
                    
                      }
                   <div className='row add-button-row'>
                            <div className='col-6 margin-top-8'>
                                <ActionButton
                                    label={'Dodaj adres email'}
                                    variant={'white'}
                                    handleClick={(e) =>
                                        this.handleAddElement('notificationEmails', {
                                            address: '',
                                            //id: undefined,
                                            uuid: uuidv4(),
                                            notificationTypeTranslated: notificationType,
                                            notificationType: null,
                                        })
                                    }
                                    iconSvg='ico_plus'
                                    iconSide='left'
                                    //disabled={this.state.element.notificationEmails.filter(el=> el.notificationTypeTranslated === notificationType).length === 5}
                                />
                            </div>
                        </div>
              </div>
             
                : null
                }
                
                    {notificationType ===  'TWO_STEP_AUTH_EDIT'  ? 
                         <div className='row'>

                         <div className='row'>
     
     
                                 <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                      <label className='p-label' style={{margin: '0px'}}>{t('profile.notificationPhoneNumber')}</label>
                                         <div className='row'>
                                             <InputTextComponent
                                                 key={`two-step-auth-phone`}
                                                 id={`two-step-auth-phone`}
                                                 name='phone'
                                                 label={'Numer telefonu'}
                                                 colClass='col-11'
                                                 viewMode={'EDIT'}
                                                 showLabel={false}
                                                 onChange = {this.handleChange}
                                                 value={this.state.element.phone}
                                                 validator={this.validator}
                                                 validators={`${this.state.element.twoStepAuthChosen === 'PHONE' ? 'required' : 'not_required'}|phone`}
                                                 keyfilter={/^[()0-9]*$/i}
                                                 forcePrefixRegEx={/^\([0-9]{1,4}\)/i}
                                                 partialPrefixRegEx={/^\([0-9]{1,4}\)|\([0-9]{1,4}|\(/gi}
                                                 defaultPrefix='(48)'
                                            />
                                         </div>
                         </div>
     
                         <div className='col-xl-4 col-lg-4 col-md-4 col-sm-12'>
                      <label className='p-label' style={{margin: '0px'}}>{t('profile.notificationEmail')}</label>
                                         <div className='row'>
                                             <InputTextComponent
                                                 key={`two-step-auth-email`}
                                                 id={`two-step-auth-email`}
                                                 name='email'
                                                 label={'Email'}
                                                 colClass='col-11'
                                                 viewMode={'EDIT'}
                                                 showLabel={false}
                                                 onChange = {this.handleChange}
                                                 value={this.state.element.email}
                                                 validator={this.validator}
                                                 validators={`${this.state.element.twoStepAuthChosen === 'EMAIL' ? 'required' : 'not_required'}|email`}
                                             />
                                         </div>
                         </div>
     
                         </div>
                         <InputRadioButtonComponent
                                                                             id={`twoStepAuthChosen-type`}
                                                                             name='twoStepAuthChosen'
                                                                             colClass='col-8 card-manage-limits'
                                                                             options={this.state.twoStepAuthPaths}
                                                                             value={this.state.element.twoStepAuthChosen}
                                                                             valueLabel='label'
                                                                             labelOnRight
                                                                             itemColClass={'col-xl-6 col-lg-6 col-md-6 col-sm-6'}
                                                                             onChange={this.handleChange}
                                                                             showLabel={true}
                                                                             validator={this.validator}
                                                                             validators='required'
                                                                             label={"Wykorzystaj "}
                                                                             viewMode={'EDIT'}
                                                                             rendered={this.props.viewMode === 'EDIT' }
                                                                             valueKey='enumValue'
                                 />    
                    
                                                         
                       
                     </div> : null
                
                
                
                }
                
                </div>
            </React.Fragment>
        );
    }
}

ContactPersonsDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'EDIT',
    visible: false,
    stationId: undefined,
};

ContactPersonsDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    beforeSave: PropTypes.func,
    elementId: PropTypes.number,
    stationId: PropTypes.number,
    notificationType: PropTypes.string,
    userAgreementMapId: PropTypes.number
};

export default withTranslation()(ContactPersonsDialog);
